<form [formGroup]="pdfViewerForm">
  <div class="row"
       *ngIf="showRubric">
    <div class="col-md-10">
      <ul class="pagination justify-content-end text-center ul col-md-3 offset-md-6">
        <li class="{{this.pageActual == 1  ? 'disabled' : ''}}">
          <a class="page-link fas fa-arrow-circle-up li" tabindex="-1" aria-disabled="true"
             (click)="changePageAfterClick(true)"></a>
        </li>
        <li
          class="{{this.pageActual == this.pagesTotal || this.pagesTotal == 0 ? 'disabled':''}}">
          <a class="page-link fas fa-arrow-circle-down li" (click)="changePageAfterClick(false)"></a>
        </li>
        <li
          class="page-item btn-paged-medium text-center">
          <input type="text"
                 id="anotherPage"
                 class="form-control"
                 data-toggle="tooltip" data-placement="top" title="{{ 'MESSAGE.ENTER-PAGE-NUMBER' | translate }}"
                 (keydown.enter)="changePageAfterEnter()"
                 formControlName="anotherPage"
                 [class.is-invalid]="isInvalidControl('anotherPage')"
                 [(ngModel)]="actualPagePaginated">
        </li>
        <li
          class="page-item btn-paged-medium text-center disabled">
          <input type="text"
                 id="totalPage"
                 class="form-control li "
                 formControlName="pagesTotal"
                 [class.is-invalid]="isInvalidControl('pagesTotal')"
                 [ngModel]="getTotalPages()">
        </li>
      </ul>
    </div>
  </div>
  <div class="overflow-auto-scroll">
    <div
      class="row {{showRubric ? 'container-box' : ''}}"
      *ngIf="!reloadingPdf">
      <div
        class="{{showRubric ? 'example-boundary' : 'col-md-12'}}"
        style="{{showRubric ? styleDimensionsPDF1 : 'min-height: 700px;'}}">
        <div class="example-box {{showRubric? 'position-relative': ''}}" id="rubricImage"
             *ngIf="showRubric"
             #resizeBox
             cdkDragBoundary=".example-boundary"
             style="{{styleDimensionsRubric2}}"
             (cdkDragEnded)="onDragEnded($event)" cdkDrag>
              <span #dragHandleCorner class="dragHandle corner" cdkDrag
                    (cdkDragMoved)="dragMove(dragHandleCorner)" (cdkDragEnded)="onDragEnded4Resize()"></span>
          <button *ngIf="isDigitalSignature()" (click)="openModalAssignSignatureDescription()"
                  data-toggle="tooltip" data-placement="top"
                  title="{{ 'TITLE.ADD-MORE-DESCRIPTIONS-TO-DIGITAL-SIGNATURE' | translate }}"
                  class="dragHandle1 corner fa fa-plus"></button>
          <img [src]="rubricSrc" class="{{hasSignatureDescriptionActive() ? 'img' : 'img1'}}"
               cdkDragBoundary=".original-pdf">
          <textarea *ngIf="hasSignatureDescriptionActive()" class="textarea auto" id="textarea"
                    style="{{styleFontSize}}"
          >{{getDescription()}}</textarea>
        </div>
        <div
          class="{{showRubric ? 'container-pdf ': 'custom-height-90 mt-2'}}"
          style="{{showRubric ? styleDimensionsPDF : ''}}">
          <ng2-pdfjs-viewer #embeddedPdf
                            [pdfSrc]="urlStream"
                            zoom="{{showRubric? '120':'auto'}}"
                            class="{{showRubric ? 'disabled1' : ''}}"
                            [page]="pageActual"
                            [download]="false"
                            [print]="false"
                            [openFile]="false"
                            [showSpinner]="false"
                            [viewBookmark]="false"
                            [startPrint]="false"
                            [fullScreen]="false"
                            pagemode="none"
                            scroll="{{showRubric ? 'H' : 'V'}}"
                            id="pdfViewer" aria-label="Embedded PDF"
                            viewerId="documentVisor">
          </ng2-pdfjs-viewer>
        </div>
      </div>
    </div>
  </div>
  <div class="row"
       *ngIf="showRubric">
    <div class="col-md-10">
      <ul class="pagination justify-content-end text-center col-md-3 offset-md-6">
        <li class="{{this.pageActual == 1  ? 'disabled' : ''}}">
          <a class="page-link fas fa-arrow-circle-up li" tabindex="-1" aria-disabled="true"
             (click)="changePageAfterClick(true)"></a>
        </li>
        <li
          class="{{this.pageActual == this.pagesTotal || this.pagesTotal == 0 ? 'disabled':''}}">
          <a class="page-link fas fa-arrow-circle-down li" (click)="changePageAfterClick(false)"></a>
        </li>
        <li
          class="page-item btn-paged-medium text-center">
          <input type="text"
                 id="anotherPage1"
                 class="form-control"
                 data-toggle="tooltip" data-placement="top" title="{{ 'MESSAGE.ENTER-PAGE-NUMBER' | translate }}"
                 (keydown.enter)="changePageAfterEnter()"
                 formControlName="anotherPage"
                 [class.is-invalid]="isInvalidControl('anotherPage')"
                 [(ngModel)]="actualPagePaginated">
        </li>
        <li
          class="page-item btn-paged-medium text-center disabled">
          <input type="text"
                 id="totalPageDown"
                 class="form-control li "
                 formControlName="pagesTotal"
                 [class.is-invalid]="isInvalidControl('pagesTotal')"
                 [ngModel]="getTotalPages()">
        </li>
      </ul>
    </div>
  </div>
</form>
